module.exports = __webpack_public_path__ + "img/horizontal_6_6_9006.1d101037.png";